import { ContactForm } from "./ContactForm";
import React from "react";

export function RegisterContact({ userId, careRecipientId, onSubmitSuccess, onCancel }: Props) {

    const onSubmit = async (form: ContactForm) => {
        if (!careRecipientId) {
            return;
        }
        const body = {
            email: form.email,
            name: form.name,
            label: form.label,
            tel1: form.tel1,
            tel2: form.tel2,
        };
        const response = await fetch(`/api/contact/${userId}/${careRecipientId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json" // eslint-disable-line
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            throw {
                code: response.status,
            };
        }
        onSubmitSuccess?.();
    };

    return (
        <ContactForm
            onSubmit={onSubmit}
            onCancel={onCancel}
        />
    );
}

type Props = {
    userId: string,
    careRecipientId: string | null,
    onSubmitSuccess?: () => void;
    onCancel: () => void;
}

